import { AddIcon, Button, Stack } from "@all-manager/design-system-v2";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { usePermissions } from "../../../../hooks/usePermissions";
import DocumentList from "../../components/DocumentList/DocumentList";
import AddDocumentsModal from "../AddDocumentsModal/AddDocumentsModal";

export default function DocumentListInSubTopic() {
  const { subTopicId } = useParams();
  const { isAdmin } = usePermissions();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  if (!subTopicId) {
    return null;
  }

  return (
    <Stack spacing={1}>
      {isAdmin ? (
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() => setIsAddModalOpen(true)}
          >
            Ajouter des documents
          </Button>
        </Stack>
      ) : null}

      <DocumentList
        filters={{ subTopicId }}
        emptySubtitle="Retrouvez ici tous les documents associés à ce sujet."
      />

      {isAddModalOpen ? (
        <AddDocumentsModal
          subTopicId={subTopicId}
          onClose={() => setIsAddModalOpen(false)}
        />
      ) : null}
    </Stack>
  );
}
